"use client";

export const RegularTshirtSizeChart = () => (
  <div className="overflow-x-auto" aria-label="Regular T-shirt size chart">
    <table className="min-w-full border-collapse text-sm sm:text-base">
      <caption className="text-left font-semibold p-2 sm:p-3">
        Regular T-Shirt — Size Chart (cm)
      </caption>
      <thead>
        <tr className="bg-gray-100 text-left">
          <th scope="col" className="px-4 py-2 font-medium">
            Size
          </th>
          <th scope="col" className="px-4 py-2 font-medium">
            Chest (cm)
          </th>
          <th scope="col" className="px-4 py-2 font-medium">
            Length (cm)
          </th>
          <th scope="col" className="px-4 py-2 font-medium">
            Shoulder (cm)
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        <tr>
          <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
            S
          </th>
          <td className="px-4 py-2 text-center">89</td>
          <td className="px-4 py-2 text-center">66</td>
          <td className="px-4 py-2 text-center">43</td>
        </tr>
        <tr>
          <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
            M
          </th>
          <td className="px-4 py-2 text-center">101</td>
          <td className="px-4 py-2 text-center">68</td>
          <td className="px-4 py-2 text-center">46</td>
        </tr>
        <tr>
          <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
            L
          </th>
          <td className="px-4 py-2 text-center">106</td>
          <td className="px-4 py-2 text-center">71</td>
          <td className="px-4 py-2 text-center">48</td>
        </tr>
        <tr>
          <th scope="row" className="px-4 py-2 text-gray-700 font-medium">
            XL
          </th>
          <td className="px-4 py-2 text-center">112</td>
          <td className="px-4 py-2 text-center">73</td>
          <td className="px-4 py-2 text-center">51</td>
        </tr>
      </tbody>
    </table>
  </div>
);
